module.exports = __webpack_public_path__ + "img/starship-freighter.a79d1905.svg";